// Advanced — single page with an internal rail mirroring 3CX's secondary nav
// (IP Blacklist / Anti-Hacking / Console Restrictions / Network / Allowed
// Country Codes / CID Rules / CID Blacklist / Secure SIP / Codecs /
// Parameters / Templates / Fax / E164 / CDR). Each section is a sub-route
// under /advanced/*. Sections reuse existing Stratus pages where possible.

import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import {
  ShieldAlert, Lock, Network as NetIcon, Globe, Phone, ListX,
  ShieldCheck, AudioLines, Sliders as SlidersIcon, FileText, Send,
  Hash, Database,
} from 'lucide-react';
import {
  IPBlacklist, AntiHacking, ConsoleRestrictions, NetworkSettings,
  AllowedCountries, CIDRules, CIDBlacklist, SecureSIP, Codecs, Parameters, XMLTemplates, E164,
  CDRSettings,
} from './AdvancedPages';
import Fax from './Fax';
import StirShaken from './StirShaken';

const SECTIONS = [
  { to: 'ip-blacklist',         label: 'IP Blacklist',          icon: ShieldAlert },
  { to: 'anti-hacking',         label: 'Anti-Hacking',          icon: Lock },
  { to: 'console-restrictions', label: 'Console Restrictions',  icon: ShieldCheck },
  { to: 'network',              label: 'Network',               icon: NetIcon },
  { to: 'country-codes',        label: 'Allowed Country Codes', icon: Globe },
  { to: 'cid-rules',            label: 'CID Rules',             icon: Phone },
  { to: 'cid-blacklist',        label: 'CID Blacklist',         icon: ListX },
  { to: 'secure-sip',           label: 'Secure SIP',            icon: ShieldCheck },
  { to: 'stir-shaken',          label: 'STIR/SHAKEN',           icon: ShieldCheck },
  { to: 'codecs',               label: 'Codecs',                icon: AudioLines },
  { to: 'parameters',           label: 'Parameters',            icon: SlidersIcon },
  { to: 'templates',            label: 'Templates',             icon: FileText },
  { to: 'fax',                  label: 'Fax',                   icon: Send },
  { to: 'e164',                 label: 'E164',                  icon: Hash },
  { to: 'cdr',                  label: 'CDR',                   icon: Database },
];

export default function Advanced() {
  return (
    <div className="grid grid-cols-[200px_1fr] gap-3">
      <nav className="card p-1 self-start">
        {SECTIONS.map(s => {
          const Icon = s.icon;
          return (
            <NavLink
              key={s.to}
              to={`/advanced/${s.to}`}
              end
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 text-sm rounded-md ${
                  isActive ? 'bg-elevated text-primary' : 'hover:bg-elevated'
                }`
              }
            >
              <Icon size={14} /> {s.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="min-w-0">
        <Routes>
          <Route index                        element={<Navigate to="/advanced/ip-blacklist" replace />} />
          <Route path="ip-blacklist"          element={<IPBlacklist />} />
          <Route path="anti-hacking"          element={<AntiHacking />} />
          <Route path="console-restrictions"  element={<ConsoleRestrictions />} />
          <Route path="network"               element={<NetworkSettings />} />
          <Route path="country-codes"         element={<AllowedCountries />} />
          <Route path="cid-rules"             element={<CIDRules />} />
          <Route path="cid-blacklist"         element={<CIDBlacklist />} />
          <Route path="secure-sip"            element={<SecureSIP />} />
          <Route path="stir-shaken"           element={<StirShaken />} />
          <Route path="codecs"                element={<Codecs />} />
          <Route path="parameters"            element={<Parameters />} />
          <Route path="templates"             element={<XMLTemplates />} />
          <Route path="fax"                   element={<Fax />} />
          <Route path="e164"                  element={<E164 />} />
          <Route path="cdr"                   element={<CDRSettings />} />
          <Route path="*"                     element={<Navigate to="/advanced/ip-blacklist" replace />} />
        </Routes>
      </div>
    </div>
  );
}
